import { useEffect } from "react"
import { Feature } from "../../components/FeatureList/FeatureList"
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton"
import TermsButtons from "../../components/TermsButtons/TermsButtons"
import { PurchasProvider, usePurchase } from "../../context/purchaseContext"
import useStrings from "../../localization/useStrings"
import images from "../../utils/images"
import svg from "../../utils/svg"

import Svg from "../../utils/svg"
import { formatCurrency, formatProductPrice } from "../../utils/utils"
import styles from "./AnimatedPaywall.module.scss"
import ScrollingImageGrid from "./ScrollingImageGrid/ScrollingImageGrid"
import Switch from "react-ios-switch"
import { useAppState } from "../../context/appStateContext"
import DelayedCloseButton from "../../components/DelayedCloseButton/DelayedCloseButton"
import native from "../../native/native"

const AnimatedPaywall = () => {
  const actions = useAppState().actions

  useEffect(() => {
    actions.setIgnoreFooterInset(true)
  }, [])

  return (
    <PurchasProvider>
      <div className={styles.container}>
        <Header />
        <Content />
      </div>
    </PurchasProvider>
  )
}

const Header = () => {
  return (
    <div className={styles.header}>
      <DelayedCloseButton
        className={styles.closeButton}
        onClick={() => native.postNativeEvent("close")}
      />
      <ScrollingImageGrid />
      <div className={styles.headerOverlay} />
      <HeaderFeatureList />
    </div>
  )
}

const HeaderFeatureList = () => {
  const strings = useStrings()

  const features: Feature[] = [
    {
      title: "Cloud Vault",
      inconSvg: svg.featureIcons.CloudVault,
      badge: strings.new,
    },
    {
      title: strings.animated.unlimitedPhotos,
      inconSvg: svg.featureIcons.Star,
    },
    {
      title: strings.decoy,
      inconSvg: svg.featureIcons.Decoy,
    },
    {
      title: strings.animated.breakinShort,
      inconSvg: svg.featureIcons.Breakin,
    },
    {
      title: strings.adFree,
      inconSvg: svg.featureIcons.Adfree,
    },
  ]

  return (
    <div className={styles.headerFeatureListContainer}>
      <div className={styles.headerFeatureList}>
        {features.map((feature, index) => (
          <div className={styles.featureContainer} key={index}>
            {<feature.inconSvg />}
            <label className={styles.featureTitle}>{feature.title}</label>
          </div>
        ))}
      </div>
    </div>
  )
}

const Content = () => {
  const defaultStrings = useStrings()
  const strings = defaultStrings.animated
  const { actions, state } = usePurchase()

  const price = formatProductPrice(state.selectedPlan.yearlyProduct)

  const originalBottomInset =
    useAppState().state.initialData?.originalBottomInset ?? 0

  return (
    <div className={styles.content}>
      <Svg.AnimatedPaywallBg
        width={"100%"}
        transform={"translate(0, -6)"}
        className={styles.svg}
        style={{
          minWidth: 300,
          alignSelf: "center",
          height: 117,
          transform: "translate(0, -116px)",
        }}
      />
      <div className={styles.contentWrapper}>
        <div className={`${styles.logo} ${images.logo.class}`} />
        <label className={styles.title}>{strings.title}</label>
        <label className={styles.price}>{strings.yearlyPrice(price)}</label>
        <label className={styles.subtitle}>{strings.subtitle}</label>
        {state.toggleableFreeTrial && <ToggleTrial />}
        <PrimaryButton
          className={styles.button}
          onClick={() => actions.purchaseCurrent()}
        >
          {strings.cta}
        </PrimaryButton>
        <TermsButtons
          containerClass={styles.termsContainer}
          buttonClass={styles.termsButton}
        />
        <div style={{ marginTop: originalBottomInset }} />
      </div>
    </div>
  )
}

const ToggleTrial = () => {
  const { state, actions } = usePurchase()

  const root = document.documentElement

  const offColor = getComputedStyle(root)
    .getPropertyValue("--pricing-selected-stroke")
    .trim()
  const strings = useStrings().animated

  return (
    <div className={styles.toggleContainer}>
      <label className={styles.toggleTitle}>{strings.trial}</label>
      <Switch
        checked={state.freeTrialToggled}
        onChange={actions.setFreeTrialToggled}
        offColor={offColor}
        onColor={"#26AD60"}
      />
    </div>
  )
}

export default AnimatedPaywall
